import React from 'react';
import PropTypes from 'prop-types';
import {TextField, SelectField, MenuItem} from 'material-ui';
import update from 'immutability-helper';
import QueueFilterSection from "./QueueFilterSection";
import StateChipSelect from "../stateChipSelect/StateChipSelect";

export default class QueueDialogItemFilter extends React.Component {

    static propTypes = {
        canChangeBoardId: PropTypes.bool.isRequired,
        onQueueDataChange: PropTypes.func.isRequired,
        project: PropTypes.PropTypes.shape({
            id: PropTypes.string,
            boards: PropTypes.array,
            flows: PropTypes.array,
            states: PropTypes.array
        }).isRequired,
        queueData: PropTypes.shape({
            name: PropTypes.string,
            boardId: PropTypes.string,
            query: PropTypes.object,
            stateIdsIncluded: PropTypes.array,
            stateIdsExcluded: PropTypes.array,
            excludeAllStates: PropTypes.bool,
            flowIdsAssigned: PropTypes.array,
            flowIdsUnassigned: PropTypes.array
        }).isRequired
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    didChangeBoardId(boardId) {
        this.props.onQueueDataChange({boardId});
    }

    didChangeQueueName(name) {
        this.props.onQueueDataChange({name});
    }

    onIncludedStateIdRemove = (stateId) => {
        let stateIdsIncluded = this.props.queueData.stateIdsIncluded;
        let index = stateIdsIncluded.indexOf(stateId);
        this.props.onQueueDataChange({
            stateIdsIncluded: update(stateIdsIncluded, {$splice: [[index, 1]]})
        });
    };

    onExcludedStateIdRemove = (stateId) => {
        let stateIdsExcluded = this.props.queueData.stateIdsExcluded;
        let index = stateIdsExcluded.indexOf(stateId);
        this.props.onQueueDataChange({
            stateIdsExcluded: update(stateIdsExcluded, {$splice: [[index, 1]]})
        });
    };

    onIncludedStateIdAdd = (stateId) => {
        this.props.onQueueDataChange({
            stateIdsIncluded: this.props.queueData.stateIdsIncluded.concat(stateId)
        });
    };

    onExcludedStateIdAdd = (stateId) => {
        this.props.onQueueDataChange({
            stateIdsExcluded: this.props.queueData.stateIdsExcluded.concat(stateId)
        });
    };

    onExcludeAllStatesChange = (excludeAllStates) => {
        this.props.onQueueDataChange({excludeAllStates});
    };

    onAssignedFlowIdRemove = (flowId) => {
        let flowIdsAssigned = this.props.queueData.flowIdsAssigned;
        let index = flowIdsAssigned.indexOf(flowId);
        this.props.onQueueDataChange({
            flowIdsAssigned: update(flowIdsAssigned, {$splice: [[index, 1]]})
        });
    };

    onUnassignedFlowIdRemove = (flowId) => {
        let flowIdsUnassigned = this.props.queueData.flowIdsUnassigned;
        let index = flowIdsUnassigned.indexOf(flowId);
        this.props.onQueueDataChange({
            flowIdsUnassigned: update(flowIdsUnassigned, {$splice: [[index, 1]]})
        });
    };

    onAssignedFlowIdAdd = (flowId) => {
        this.props.onQueueDataChange({
            flowIdsAssigned: this.props.queueData.flowIdsAssigned.concat(flowId)
        });
    };

    onUnassignedFlowIdAdd = (flowId) => {
        this.props.onQueueDataChange({
            flowIdsUnassigned: this.props.queueData.flowIdsUnassigned.concat(flowId)
        });
    };

    onQueryChange = (query) => {
        this.props.onQueueDataChange({query});
    };

    renderBoardSelectField() {
        return (
            <SelectField
                className="custom-field custom-select-field"
                fullWidth={true}
                floatingLabelText="Board"
                floatingLabelFixed={true}
                hintText="Choose Board"
                disabled={!this.props.canChangeBoardId}
                value={this.props.queueData.boardId}
                onChange={(event, index, value) => this.didChangeBoardId(value)}
            >
                <MenuItem value={null} primaryText=""/>
                {this.props.project.boards.map(board =>
                    <MenuItem key={board.id} value={board.id} primaryText={board.name}/>
                )}
            </SelectField>
        );
    }

    render() {
        return (
            <form className="queueDialogItemFilter">

                <TextField
                    className="custom-field"
                    fullWidth={true}
                    floatingLabelText="Queue Name"
                    floatingLabelFixed={true}
                    hintText="Enter title for the queue"
                    value={this.props.queueData.name}
                    onChange={(event) => this.didChangeQueueName(event.target.value)}
                />
                {this.renderBoardSelectField()}

                <StateChipSelect
                    project={this.props.project}
                    excludeAllStates={this.props.queueData.excludeAllStates}
                    stateIdsIncluded={this.props.queueData.stateIdsIncluded}
                    stateIdsExcluded={this.props.queueData.stateIdsExcluded}
                    flowIdsAssigned={this.props.queueData.flowIdsAssigned}
                    flowIdsUnassigned={this.props.queueData.flowIdsUnassigned}
                    onExcludeAllStatesChange={this.onExcludeAllStatesChange}
                    onIncludedStateIdRemove={this.onIncludedStateIdRemove}
                    onExcludedStateIdRemove={this.onExcludedStateIdRemove}
                    onIncludedStateIdAdd={this.onIncludedStateIdAdd}
                    onExcludedStateIdAdd={this.onExcludedStateIdAdd}
                    onAssignedFlowIdRemove={this.onAssignedFlowIdRemove}
                    onUnassignedFlowIdRemove={this.onUnassignedFlowIdRemove}
                    onAssignedFlowIdAdd={this.onAssignedFlowIdAdd}
                    onUnassignedFlowIdAdd={this.onUnassignedFlowIdAdd}
                />

                <QueueFilterSection
                    projectId={this.props.project.id}
                    onQueryChange={this.onQueryChange}
                    query={this.props.queueData.query}/>

            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/queue/QueueDialogItemFilter.js